import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { AgGridModule } from 'ag-grid-angular';

import { WjChartModule } from '@grapecity/wijmo.angular2.chart';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { QRCodeComponent } from 'angularx-qrcode';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { GoogleMapsModule } from '@angular/google-maps';
import { NgChartsModule } from 'ng2-charts';


import { PipesModule } from '../pipes/pipes.module';
import { ClientComponent } from './customers/client/view/client.component';

import { AccountSettingsComponent } from './core/account-settings/account-settings.component';
import { PerfilComponent } from './core/perfil/view/perfil.component';

import { AreasComponent } from './core/areas/areas.component';
import { EmpleadosComponent } from './core/employees/empleados.component';


import { SubareasComponent } from './core/subareas/subareas.component';
import { EmpleadoComponent } from './core/employees/empleado.component';

import { InstallationOrderComponent } from './orders/installation/view/installation-order.component';
import { ManagementOrderComponent } from './orders/management/view/management-order.component';
import { ServiceWorkComponent } from './orders/service-work/view/service-work.component';



import { WidgetsModule } from '../shared/widgets.module';
import { EcoInfoTabComponent } from './customers/resume/components/eco-info-tab/eco-info-tab.component';
import { ChangeLogTabComponent } from './customers/resume/components/change-log-tab/change-log-tab.component';
import { ZonesSelectComponent } from './core/selects/zones-select/zones-select.component';
import { StatesSelectComponent } from './core/selects/states-select/states-select.component';
import { BusinesstypeSelectComponent } from './core/selects/businesstype-select/businesstype-select.component';


import { SelectsComponent } from './core/selects/selects.component';
import { ControlComponent } from './core/control/control.component';
import { BusquedaComponent } from './search/busqueda.component';

import { BiComponent } from './bi/view/bi.component';
import { SurveysComponent } from './customers/survey/surveys/surveys.component';
import { AgreementsComponent } from './customers/agreement/agreements/view/agreements.component';
import { AgreementComponent } from './customers/agreement/agreement/view/agreement.component';
import { PreInstallationSurveyComponent } from './customers/survey/pre-installation-survey/pre-installation-survey.component';
import { OilRecoveryComponent } from './customers/oil-recovery/oil-recovery.component';

import { TankOrderComponent } from './orders/tank/view/tank-order.component';
import { WorkreqSelectComponent } from './core/selects/workreq-select/workreq-select.component';
import { DashboardComponent } from './core/dashboard/dashboard.component';
import { MegaMenuComponent } from './core/mega-menu/mega-menu.component';
import { OilCollectionComponent } from './customers/oil-collection/oil-collection.component';
import { OilCollectionDetailsComponent } from './customers/oil-collection/modals/oil-collection-details/oil-collection-details.component';
import { RemoteOilCollectionModalComponent } from './customers/oil-collection/modals/remote-oil-collection-modal/remote-oil-collection-modal.component';
import { UpperCaseInputDirective } from '../directives/to-uppercase.directive';
import { KiteModule } from '../shared/widgets/kite/kite.module';

import { ResumeComponent } from './customers/resume/resume.component';
// EcoClientsComponent and CreateClientsComponent moved to EcoModule
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { DatePipe } from '@angular/common';
import { CreateOticketComponent } from './eco/create-oticket/create-oticket.component';
import { MapComponent } from './customers/map/map.component';
import { SharedModule } from '../layout/shared/shared.module';
import { ReportsComponent } from './customers/reports/reports.component';
import { MatTabsModule } from '@angular/material/tabs';
import { LiquidationsComponent } from './liquidations/liquidations.component';
import { ClientsMapLocationsComponent } from './customers/reports/clients-map-locations/clients-map-locations.component';
import { OilCollectionSummaryComponent } from './customers/reports/oil-collection-summary/oil-collection-summary.component';
import { ClientPerfomanceSummaryComponent } from './customers/resume/components/client-perfomance-summary/client-perfomance-summary.component';
import { InstallationsStatusReportComponent } from './customers/reports/installations-status-report/installations-status-report.component';
import { FinancialAnalysisReportComponent } from './customers/reports/financial-analysis-report/financial-analysis-report.component';
import { CustomReportComponent } from './customers/reports/custom-report/custom-report.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UserManagementComponent } from './core/user-management/user-management.component';
import { CreateUserModalComponent } from './core/user-management/modals/create-user-modal/create-user-modal.component';
import { EditUserModalComponent } from './core/user-management/modals/edit-user-modal/edit-user-modal.component';
import { ResetPasswordModalComponent } from './core/user-management/modals/reset-password-modal/reset-password-modal.component';
import { DirectivesModule } from '../directives/directives.module';
import { BenefitRulesComponent } from './core/benefit-rules/benefit-rules.component';
import { CreateBenefitRuleModalComponent } from './core/benefit-rules/modals/create-benefit-rule-modal/create-benefit-rule-modal.component';
import { EditBenefitRuleModalComponent } from './core/benefit-rules/modals/edit-benefit-rule-modal/edit-benefit-rule-modal.component';
import { EcoLayoutContainerComponent } from './eco/layout/eco-layout-container.component';
import { EcoLayoutModule } from './eco/layout/eco-layout.module';
import { CustomTabsComponent } from '../shared/components/custom-tabs/custom-tabs.component';
import { CustomTabComponent } from '../shared/components/custom-tabs/custom-tab.component';
import { BasicInfoTabComponent } from './customers/resume/components/basic-info-tab/basic-info-tab.component';
import { CustomerOrdersTabComponent } from './customers/resume/components/customer-orders-tab/customer-orders-tab.component';
import { CustomerEcoOrdersTabComponent } from './customers/resume/components/customer-eco-orders-tab/customer-eco-orders-tab.component';
import { OilCollectionResumeTabComponent } from './customers/resume/components/oil-collection-resume-tab/oil-collection-resume-tab.component';
import { QbFinancialTabComponent } from './customers/resume/components/qb-financial-tab/qb-financial-tab.component';
import { ClienteInformationCardComponent } from '../shared/components/cliente-information-card/cliente-information-card.component';
import { OrdersCalendarComponent } from '../shared/components/orders-calendar/orders-calendar.component';



@NgModule({
  declarations: [
    ClientComponent,
    AccountSettingsComponent,
    PerfilComponent,

    AreasComponent,
    EmpleadosComponent,
    EmpleadoComponent,
    BusquedaComponent,
    SubareasComponent,
    AgreementComponent,
    InstallationOrderComponent,
    ManagementOrderComponent,
    ServiceWorkComponent,
    TankOrderComponent,
    PreInstallationSurveyComponent,
    ZonesSelectComponent,
    StatesSelectComponent,
    BusinesstypeSelectComponent,
    SelectsComponent,
    ControlComponent,
    SurveysComponent,
    AgreementsComponent,
    WorkreqSelectComponent,
    DashboardComponent,
    OilRecoveryComponent,
    OilCollectionComponent,
    UpperCaseInputDirective,
    BiComponent,
    ResumeComponent,
    // EcoClientsComponent and CreateClientsComponent moved to EcoModule
    
    
    
    CreateOticketComponent,
    MapComponent,
    ReportsComponent,
    ClientsMapLocationsComponent,
    OilCollectionSummaryComponent,
    LiquidationsComponent,
    InstallationsStatusReportComponent,
    FinancialAnalysisReportComponent,
    CustomReportComponent,
    UserManagementComponent,
    CreateUserModalComponent,
    EditUserModalComponent,
    ResetPasswordModalComponent,
    OilCollectionDetailsComponent,
    RemoteOilCollectionModalComponent,
    BenefitRulesComponent,
    CreateBenefitRuleModalComponent,
    EditBenefitRuleModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PipesModule,
    NgbPaginationModule,
    NgbTooltipModule,
    WidgetsModule,
    KiteModule,
    AngularSignaturePadModule,
    AgGridModule,
    WjChartModule,
    WjInputModule,
    QRCodeComponent,
    CurrencyMaskModule,
    AutocompleteLibModule,
    WjNavModule,
    SharedModule,
    MatTabsModule,
    GoogleMapsModule,
    NgChartsModule,
    DirectivesModule,
    EcoLayoutModule,
    CustomTabsComponent,
    CustomTabComponent,
    BasicInfoTabComponent,
    CustomerOrdersTabComponent,
    CustomerEcoOrdersTabComponent,
    OilCollectionResumeTabComponent,
    QbFinancialTabComponent,
    ClientPerfomanceSummaryComponent,
    EcoInfoTabComponent,
    ChangeLogTabComponent,
    MegaMenuComponent,
    ClienteInformationCardComponent,
    OrdersCalendarComponent
  ],
  exports: [],
  providers: [CurrencyPipe, DatePipe],
})
export class PagesModule { }
